<script lang="ts" setup>
import CalendarService from '@/core/shared/calendar/calendar.service';
import { CalendarConnectionStatus } from '@/core/shared/calendar/types/calendar.types';
import { computed } from 'vue';

const calendarService = new CalendarService();
const showPermissionUpgradeWarning = computed(() => {
  return (
    calendarService.connectionStatus === CalendarConnectionStatus.ACTIVE &&
    calendarService.currentUserNeedsUpgrade &&
    calendarService.calendarConnectionOauthUrl &&
    !calendarService.connectionFlowActive
  );
});

async function handleConnectClick() {
  await calendarService.connectCalendar();
}
</script>

<template>
  <div
    class="flex gap-4 rounded-lg bg-highlight-50 p-4 text-sm font-normal"
    v-if="showPermissionUpgradeWarning"
  >
    <div>
      <img class="w-8" src="@/assets/png/refresh-highlight.png" />
    </div>
    <div class="flex flex-col">
      <p class="text-shade-840">
        Reconnect your calendar to enable instant booking and automatic Meet/Teams links.
      </p>
      <a
        :href="calendarService.calendarConnectionOauthUrl!"
        class="text-highlight-600"
        target="_blank"
        @click="handleConnectClick"
      >
        Reconnect your calendar
      </a>
    </div>
  </div>
</template>
